import { useState, useEffect, useCallback } from "react";

// Editable state for the plane-layout walkable-area polygon.
// `vertices` is an array of [x, y] meter pairs (backend `boundary_area` format).
// `drawing` = true while the operator is still dropping points (open polyline);
// false once the ring is closed and vertices are drag/delete editable.
export const useAreaPolygon = (loadedBoundary, open) => {
  const [vertices, setVertices] = useState([]);
  const [drawing, setDrawing] = useState(false);

  // Re-seed from the loaded config whenever it changes or the modal (re)opens.
  useEffect(() => {
    const initial = Array.isArray(loadedBoundary) ? loadedBoundary : [];
    setVertices(initial);
    setDrawing(initial.length === 0);
  }, [loadedBoundary, open]);

  const addVertex = useCallback((pt) => {
    setVertices((prev) => [...prev, pt]);
  }, []);

  const moveVertex = useCallback((index, pt) => {
    setVertices((prev) => prev.map((v, i) => (i === index ? pt : v)));
  }, []);

  const removeVertex = useCallback((index) => {
    setVertices((prev) =>
      prev.length <= 3 ? prev : prev.filter((_, i) => i !== index),
    );
  }, []);

  const undo = useCallback(() => {
    setVertices((prev) => prev.slice(0, -1));
  }, []);

  const clear = useCallback(() => {
    setVertices([]);
    setDrawing(true);
  }, []);

  const finish = useCallback(() => {
    setDrawing(false);
  }, []);

  return {
    vertices,
    drawing,
    setDrawing,
    addVertex,
    moveVertex,
    removeVertex,
    undo,
    clear,
    finish,
  };
};
